import React from 'react'
import _ from 'lodash'

import { brandCurrencyPrefixes, brandCurrencySuffixes } from '../../../configuration/brand'
import DestinationTags from './DestinationTags'
import labels from '../../../configuration/labels'
import '../../../styles/scss/elements/hero.scss'

const HeroDetailsRailbookers = props => {
  const {
    brand,
    containerClasses,
    discountText,
    title,
    tags,
    numCountries,
    numDays,
    numDestinations,
    roundTripUpgradePrice,
  } = props

  const visibleCounts = _.size(_.filter([Boolean(numDays), Boolean(numCountries > 1), Boolean(numDestinations)]))

  return (
    <div className={`hero-details ${containerClasses}`}>
      <div className="u-flex u-flex-space-between">
        <div className="u-full-width u-flex u-flex-column">
          {discountText && (
            <div
              className="hero-details__discount"
              dangerouslySetInnerHTML={{ __html: discountText }}
            />
          )}
          <h1>{title}</h1>
        </div>
      </div>
      <div className="hero-details__content-container">
        <div
          className="u-flex u-flex-wrap hero-details__content-container__content-counts-container"
          style={{justifyContent: visibleCounts > 2 ? 'space-between' : 'space-around'}}
        >
          {Boolean(numDays) && (
            <div className="u-flex u-flex-column u-flex-align-center content-counts">
              {numDays}
              <span className="u-flex content-counts-days">
                {`${labels.day}${numDays > 1 ? 's' : ''}`}
              </span>
            </div>
          )}
          {Boolean(numCountries > 1) && (
            <>
              {numDays && <div className="hero-details__content-container__content-counts-spacer" />}
              <div className="u-flex u-flex-column u-flex-align-center content-counts">
                {numCountries}
                <span className="u-flex content-counts-countries">
                  {labels.countries}
                </span>
              </div>
            </>
          )}
          {Boolean(numDestinations) && (
            <>
              {(numDays || numCountries) && <div className="hero-details__content-container__content-counts-spacer" />}
              <div className="u-flex u-flex-column u-flex-align-center content-counts">
                {numDestinations}
                <span className="u-flex content-counts-destinations">
                  {`${labels.destination}${numDestinations > 1 ? 's' : ''}`}
                </span>
              </div>
            </>
          )}
        </div>
        <div className=" hero-details__content-container__tags-container">
          {!_.isEmpty(tags) && <DestinationTags destinations={tags} disabled />}
        </div>
        {!!roundTripUpgradePrice && (
          <p className="hero-details__round-trip-upgrade">
            Rather take the train? Upgrades start from {brandCurrencyPrefixes[brand] || '$'}{roundTripUpgradePrice}{brandCurrencySuffixes[brand] || ''}. Call for more details.
          </p>
        )}
      </div>
    </div>
  )
}

export default HeroDetailsRailbookers
